<template>
  <div>
    <!-- <div v-if="terminalView === 'selectTransferType'">
      <select-transfer-type @toggleView ="toggleView" />
    </div> -->
    <div v-if="!isLoading">
      <terminal-skeleton @terminalPage="terminalPage" />
    </div>
    <div v-else>
      <el-skeleton class="w-full" animated>
        <template slot="template">
          <div class="px-10 grid grid-cols-10 md:ml-20">
            <div
              class="col-span-10 md:col-span-7 px-10 md:ml-20 mt-2 flex gap-x-10"
            >
              <el-skeleton-item variant="text"></el-skeleton-item>
              <el-skeleton-item variant="text"></el-skeleton-item>
              <el-skeleton-item variant="text"></el-skeleton-item>
              <el-skeleton-item variant="text"></el-skeleton-item>
            </div>
            <div class="mt-6 lg:mt-16 col-span-10 md:col-span-6">
              <el-skeleton-item
                variant="rect"
                class="flex rounded-lg justify-center items-center col-span-10 md:col-span-6 px-5 h-20 md:h-24 md:ml-20"
              />
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script>
import localDeposit from '@/mixins/localDeposit.js'
import hasKyc from '@/mixins/app.js'

export default {
  mixins: [localDeposit, hasKyc],
  components: {
    TerminalSkeleton: () =>
      import('@/components/terminal/terminalSkeleton/Index.vue')
    // SelectTransferType: () =>
    //   import('@/components/terminal/selectTransferType/Index.vue')
  },
  data () {
    return {
      terminalView: 'selectTransferType',
      transferDetailsInterval: null,
      isLoading: false
    }
  },
  methods: {
    getDetails () {
      this.getTransferDetails()
    },
    toggleView () {
      this.terminalView = 'transferSkeleton'
    },
    terminalPage () {
      this.terminalView = 'selectTransferType'
    }
  },
  async mounted () {
    if (this.hasKyc) {
      this.isLoading = true
      await this.getTransferDetails()
      this.getWalletAddresses()
      this.isLoading = false
      this.transferDetailsInterval = setInterval(
        async () => await this.getDetails(),
        30000
      )
      this.setDefaultCurrencies()
    }
  },
  destroyed () {
    this.$store.dispatch('terminal/resetTerminalState')
    this.$store.dispatch('transactions/wireTransferType', '')
    clearInterval(this.transferDetailsInterval)
  }
}
</script>

<style lang="scss" scoped></style>
